import Button from "../Button";
import { CUSTOMER_PORTAL_URL } from "../../lib/portal";
import { usePublicAuth } from "../../context/PublicAuthContext";

export default function CTA() {
  const { user, loading: authLoading } = usePublicAuth();
  return (
    <section className="relative overflow-hidden bg-bridge">
      <div className="absolute -right-24 top-[-140px] h-[360px] w-[360px] rounded-full bg-white/20 blur-3xl" />
      <div className="container relative flex flex-col gap-7 py-16 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="eyebrow text-ink/60">Ready when you are</p>
          <h2 className="mt-3 max-w-2xl font-display text-3xl font-extrabold tracking-[-.04em] text-ink sm:text-4xl">
            Bring us what you need. We will help move the details.
          </h2>
        </div>
        {!authLoading && <Button href={`${CUSTOMER_PORTAL_URL}/${user ? "dashboard" : "signup"}`} variant="dark">
          {user ? "Open dashboard" : "Get started"}
        </Button>}
      </div>
    </section>
  );
}
